export default {
  login_mfa: {
    title: '@:login.title',
    message: 'Sie haben eine SMS mit einem \nVerifizierungscode an Ihre \nregistrierte Telefonnummer erhalten.',
    button_submit: '@:login.login',
    button_resend: 'Verifizierungscode erneut senden',
    alert_success: 'Der Verifizierungscode wurde erneut gesendet',
    alert_error: 'Erneutes Senden des Verifizierungscodes ist fehlgeschlagen',
    error: '@:common.error.code_9999',
    no_phone_number_message: 'Die SMS-Authentifizierung konnte nicht verwendet werden, da die Rufnummer des Benutzers nicht registriert ist.\n\nWenden Sie sich an den Administrator Ihres Unternehmens, um Ihre Rufnummer hinzuzufügen.',
  },
}
